// @ts-nocheck
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";

export const isProductDiscountinued = (productInfo: ProductInfo) => {
    const { inventory, unitOfMeasure } = productInfo;
    const inventoryAvailability = inventory?.inventoryAvailabilityDtos?.find(o => o.unitOfMeasure === unitOfMeasure);
    const isOutOfStock =
        inventoryAvailability?.availability &&
        inventoryAvailability.availability.messageType === AvailabilityMessageType.OutOfStock;
    const isDiscountinued = getBooleanProperty(inventory?.additionalResults?.isDiscontinued);

    return Boolean(isDiscountinued && isOutOfStock);
};
